module.exports = __webpack_public_path__ + "static/img/24.52e37bff.gif";